import React from 'react'
import { Link } from 'react-router-dom'

import Icon from '../../../../components/icon'

export default function FlowShell({
  styles,
  t,
  eventBasePath,
  thumbSrc,
  eventTitle,
  formattedLocation,
  event,
  organizerName,
  volunteerCount,
  totalHours,
  showStepper,
  stepperItems,
  children,
}) {
  return (
    <div className={styles.root}>
      <div className={styles.topBar}>
        <Link to="/" className={styles.crLogo}>
          <img
            className={styles.crLogoImg}
            src="/images/CivicRush-Logo-500x162.png"
            alt=""
          />
        </Link>
        <div className={styles.topSecure}>
          <Icon name="lock-alt" />
          {t('sponsorPledgeFlow.secureApplication')}
        </div>
      </div>

      <div className={styles.eventHeader}>
        <div className={styles.eventHeaderInner}>
          {thumbSrc ? (
            <Link to={eventBasePath}>
              <img className={styles.eventThumb} src={thumbSrc} alt="" />
            </Link>
          ) : (
            <div className={styles.eventThumb} />
          )}
          <div>
            <div className={styles.eventTitle}>
              <Link
                to={eventBasePath}
                className="text-decoration-none text-reset"
              >
                {eventTitle}
              </Link>
            </div>
            <div className={styles.eventMetaLine}>
              {formattedLocation ? (
                <a
                  href={`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(
                    formattedLocation,
                  )}`}
                  target="_blank"
                  rel="noreferrer"
                >
                  {formattedLocation}
                </a>
              ) : (
                <span>{t('sponsorPledgeFlow.header.locationTbd')}</span>
              )}
            </div>
            <div className={styles.eventMetaLine}>
              {t('sponsorPledgeFlow.header.by')}{' '}
              {event?.user?.nickname ? (
                <Link
                  to={`/profile/${encodeURIComponent(event.user.nickname)}`}
                >
                  {organizerName}
                </Link>
              ) : (
                <span>{organizerName}</span>
              )}
              {event?.user?.charity_verified === true ? (
                <span className={styles.npoVerified}>
                  {t('sponsorPledgeFlow.header.verifiedNpo')}
                </span>
              ) : null}
            </div>
            <div className={styles.eventStats}>
              {volunteerCount > 0
                ? t('sponsorPledgeFlow.header.volunteerStats', {
                    count: volunteerCount,
                    hours: totalHours ?? '—',
                  })
                : null}
            </div>
          </div>
        </div>
      </div>

      {showStepper ? (
        <div className={styles.stepperWrap}>
          <div className={styles.stepper}>{stepperItems}</div>
        </div>
      ) : null}

      <div className={styles.mainContent}>{children}</div>
    </div>
  )
}
